import { createGlobalStyle } from 'styled-components';
 
export const GlobalStyle = createGlobalStyle`
*{
    margin: 0;
    padding: 0;
    font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
}
`